module.exports = __webpack_public_path__ + "static/img/cyx4.bc20a710.png";